<template>
  <div class="palette-container flex align-items-center gap-2">
    <!-- Bouton pour le mode clair/sombre -->
    <button @click="themeStore.toggleDarkMode()" class="theme-button" aria-label="Basculer le thème">
      <i :class="['pi', themeStore.isDarkMode ? 'pi-sun' : 'pi-moon']" style="font-size: 1.2rem"></i>
    </button>

    <!-- Bouton pour ouvrir la palette -->
    <button @click="togglePalette" class="theme-button" aria-label="Ouvrir la palette de couleurs">
      <i class="pi pi-palette" style="font-size: 1.2rem"></i>
    </button>

    <!-- Modal/Panel de la palette -->
    <div v-if="isPaletteVisible" class="palette-modal shadow-4 fadein-up">
      <div class="flex gap-2">
        <button v-for="color in themeStore.availableColors" :key="color.name"
                class="color-swatch shadow-1"
                :class="{ 'selected': themeStore.primaryColor === color.name }"
                :style="{ backgroundColor: color.hex }"
                @click="selectColor(color.name)"
                :aria-label="`Changer la couleur pour ${color.name}`">
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useThemeStore } from '@/stores/theme';

const isPaletteVisible = ref(false);
const themeStore = useThemeStore();

const togglePalette = () => {
  isPaletteVisible.value = !isPaletteVisible.value;
};

const selectColor = (colorName) => {
  themeStore.setColor(colorName);
  // Optionnel: fermer la palette après sélection
  // isPaletteVisible.value = false;
};
</script>

<style scoped>
.palette-container {
  position: relative;
  z-index: 50;
}

.theme-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background-color: var(--surface-card);
  color: var(--text-color);
  border: 1px solid var(--surface-border);
  cursor: pointer;
  transition: all 0.2s ease;
}

.theme-button:hover {
  background-color: var(--surface-hover);
  transform: translateY(-2px);
}

.palette-modal {
  position: absolute;
  bottom: 100%; /* Position au-dessus */
  left: 0;
  margin-bottom: 1rem;
  background-color: var(--surface-card);
  border: 1px solid var(--surface-border);
  border-radius: 2rem; /* Arrondi style "capsule" */
  padding: 0.75rem;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.color-swatch {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid transparent;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  padding: 0;
}

.color-swatch:hover {
  transform: scale(1.15);
}

.color-swatch.selected {
  transform: scale(1.1);
  border-color: var(--text-color);
  box-shadow: 0 0 0 2px var(--surface-card), 0 0 0 4px var(--text-color);
}

/* Animation simple */
.fadein-up {
  animation: fadeInUp 0.2s ease-out forwards;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
